





















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { StudioService } from "../services/roomService";
import { QuickConnectCode } from "../interfaces/quickConnectCode";
import { DateService } from "@/services/dateService";
@Component
export default class QuickConnectDialog extends Vue {
    @Prop() studioId!: string;
    @Prop() token!: string;

    public showPicker: boolean = false;
    public picker: string = DateService.addDays(new Date(), 1)
        .toISOString()
        .substr(0, 10);

    public selectedCode: number = 0;
    public navigator = navigator;

    public get datePickerOptions() {
        return {
            min: DateService.addDays(new Date(), 1)
                .toISOString()
                .substr(0, 10),
            max: DateService.addDays(new Date(), 30)
                .toISOString()
                .substr(0, 10),
        };
    }

    public get codes(): QuickConnectCode[] {
        const ownStudios = this.$store.state.user.own_studios || [];
        const IdToFilter = this.studioId;
        const yesterday = DateService.addDays(new Date(), -1);
        const filteredStudios = ownStudios.find(
            (i: { studio: { studioId: string } }) =>
                i.studio.studioId === IdToFilter
        );

        return filteredStudios.studio.quick_connect_codes.filter(
            (code: QuickConnectCode) => {
                return new Date(code.validTo) > yesterday;
            }
        );
    }

    public handleItemHover(index: number) {
        this.selectedCode = index;
    }

    public dateParse(date: string) {
        let minusdate: string;
        try {
            minusdate = this.subtractOneMinute(date + "Z");
        } catch (error) {
            minusdate = this.subtractOneMinute(date);
        }
        return DateService.formatIsoStringShort(minusdate, this.$i18n.locale);
    }

    public subtractOneMinute(date: string): string {
        const minusdate: Date = new Date(date);
        minusdate.setUTCSeconds(minusdate.getUTCSeconds() - 1);
        return minusdate.toISOString();
    }

    public async addCode() {
        const pickerDate = new Date(this.picker);
        const localizedDate = new Date(
            pickerDate.getFullYear(),
            pickerDate.getMonth(),
            pickerDate.getDate(),
            0
        ).toISOString();

        const response = await StudioService.createQuickConnectCode(
            this.$store.state.studio.studioId,
            localizedDate,
            this.token
        );

        if (response.status == 200) {
            this.$store.commit("addQuickConnectCode", {
                code: response.data,
                studioId: this.$store.state.studio.studioId,
            });
            this.$store.commit("showSnackbar", {
                text: "Added Code: " + response.data.id,
                color: "success",
            });
        } else {
            this.$store.commit("showSnackbar", {
                text: response.data.detail,
                color: "error",
            });
        }
    }

    public copyToClipboard(idToCopy: string) {
        navigator.clipboard.writeText(idToCopy);
        this.$store.commit("showSnackbar", {
            text: this.$t("studio.copyToClipboard"),
            color: "success",
        });
    }
    public async deleteCode(code: QuickConnectCode) {
        const deleted = await StudioService.deleteQuickConnectCode(
            code.id,
            this.token
        );
        this.$store.commit("removeQuickConnectCode", {
            code: code,
            studioId: this.$store.state.studio.studioId,
        });
        this.$store.commit("showSnackbar", {
            text: "Removed Code: " + code.id,
            color: "error",
        });
        return deleted;
    }
}
